<ng-container *ngIf="listingsRatePlans?.length > 0 && hasMultipleRatePlans">
  <mat-divider *ngIf="showDivider" class="!my-6"></mat-divider>
  <div class="flex gap-4 items-center justify-between">
    <h3 class="nomargin flex-1">Primary rate plan</h3>

    <sbnb-save-indicator [saveStatus]="saveStatus$ | async"></sbnb-save-indicator>
  </div>

  <div class="@container">
    <p class="text__small">
      Choose which Booking.com rate plan you want to manage on {{ 'CORE.PRODUCT_NAME' | transloco }}.
    </p>

    <div *ngFor="let listingRatePlans of listingsRatePlans">
      <div
        class="flex @md:items-center @md:gap-3 gap-1 mb-4 @md:flex-row flex-col"
        *ngIf="listingRatePlans.rate_plans.length > 1">
        <span class="flex flex-1 text-sm items-center justify-between gap-1">
          <div class="flex items-center justify-center gap-3 flex-1">
            <sbnb-mini-listing-img
              [imgSrc]="listingRatePlans.picture"
              imgWidth="26px"
              imgHeight="20px"></sbnb-mini-listing-img>
            <span class="strong flex-1 truncate">{{ listingRatePlans.name }}</span>
          </div>
          <sbnb-property-update-status
            class="@md:hidden mr-[2px]"
            [hasAirbnbListing]="false"
            [hasBookingListing]="listingRatePlans.platform === 'booking'"
            [hasAgodaListing]="listingRatePlans.platform === 'agoda'"
            [hasDirectSites]="false"></sbnb-property-update-status>
        </span>

        <div class="flex flex-row items-center gap-3">
          <sbnb-property-update-status
            class="hidden @md:block"
            [hasAirbnbListing]="false"
            [hasBookingListing]="listingRatePlans.platform === 'booking'"
            [hasAgodaListing]="listingRatePlans.platform === 'agoda'"
            [hasDirectSites]="false"></sbnb-property-update-status>

          <mat-form-field class="nopadding nomargin w-full">
            <mat-select
              [value]="selectedRatePlans[listingRatePlans.listing_id]?.uuid"
              (selectionChange)="updateRatePlan(listingRatePlans.listing_id, $event)">
              <mat-option *ngFor="let plan of listingRatePlans.rate_plans" [value]="plan.uuid">
                {{ plan.name | titlecase }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
</ng-container>
